import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { merge } from '../../utils/utility';
import { HeaderPage } from './SiteHeader';

interface HeaderLinkProps {
  page: HeaderPage;
}

export const HeaderLink: FC<HeaderLinkProps> = ({ page }) => {
  const baseClass = 'text-primary-800 font-semibold py-2 border-b-2 flex items-center border-box';
  return (
    <NavLink className={({ isActive }) => merge(baseClass, isActive ? 'border-primary-800' : 'border-transparent')} to={page.url}>
      {page.name}
    </NavLink>
  );
};
